import { render } from "./AchievementHeader.vue?vue&type=template&id=2bb5ec46&scoped=true"
import script from "./AchievementHeader.vue?vue&type=script&lang=js"
export * from "./AchievementHeader.vue?vue&type=script&lang=js"

import "./AchievementHeader.vue?vue&type=style&index=0&id=2bb5ec46&scoped=true&lang=scss"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb5ec46"]])

export default __exports__